import React from 'react';

function ToastElement(props) {
	return (
		<div className={`toast-component-${props?.theme}`}>
			{props?.header && (
				<span className={`toast-header-${props?.theme}`}>{props?.header}</span>
			)}
			<span className={`toast-body-${props?.theme}`}>{props?.message}</span>
		</div>
	);
}

export default ToastElement;
